import { render, staticRenderFns } from "./showbundling.vue?vue&type=template&id=adb7151a&scoped=true"
import script from "./showbundling.vue?vue&type=script&lang=js"
export * from "./showbundling.vue?vue&type=script&lang=js"
import style0 from "./showbundling.vue?vue&type=style&index=0&id=adb7151a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb7151a",
  null
  
)

export default component.exports